import { TrendingUp } from "lucide-react";

const TIER_LABELS = { signal: "Signal", sentinel: "Sentinel", director: "Director", sovereign: "Sovereign" };
const EVENT_LABELS = { signup: "New Subscription", upgrade: "Upgrade", downgrade: "Downgrade", cancellation: "Cancellation" };

export const AdminRevenuePanel = ({ data }) => {
  if (!data) return null;
  return (
    <div className="rounded-lg border border-surface-border bg-surface-card p-6" data-testid="admin-revenue-panel">
      <div className="mb-3 flex items-center gap-2">
        <TrendingUp className="h-4 w-4 text-truth-green" />
        <h3 className="font-heading text-lg font-bold text-white">Sovereign Pulse Subscriptions</h3>
      </div>
      <div className="mb-4 grid grid-cols-2 gap-3 sm:grid-cols-5">
        <div className="rounded-md border border-truth-green/40 bg-truth-green/5 p-3" data-testid="admin-revenue-mrr">
          <p className="font-heading text-xl font-bold text-truth-green">${data.mrr.toFixed(0)}</p>
          <p className="text-xs text-slate-500">MRR</p>
        </div>
        {Object.entries(data.active_by_tier).map(([tier, count]) => (
          <div key={tier} className="rounded-md border border-surface-border bg-obsidian p-3" data-testid={`admin-revenue-tier-${tier}`}>
            <p className="font-heading text-xl font-bold text-white">{count}</p>
            <p className="text-xs text-slate-500">{TIER_LABELS[tier] || tier}</p>
          </div>
        ))}
      </div>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">Recent Subscription Events</p>
      {data.recent_events.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="admin-revenue-events-empty">No subscription events yet.</p>
      ) : (
        <ul className="space-y-1.5" data-testid="admin-revenue-events-list">
          {data.recent_events.map((e) => (
            <li key={e.id} className="text-xs text-slate-400" data-testid={`admin-revenue-event-${e.id}`}>
              <span className="font-semibold text-white">{e.email}</span> &mdash; {EVENT_LABELS[e.kind] || e.kind}
              {e.previous_tier && e.new_tier && ` (${TIER_LABELS[e.previous_tier] || e.previous_tier} \u2192 ${TIER_LABELS[e.new_tier] || e.new_tier})`}
              <span className="ml-2 text-slate-500">{new Date(e.created_at).toLocaleString()}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
